import React from "react";
import Form from "./ContactForm";
import pdf from "../documents/esther-inyang-resume.pdf";
import { HashLink } from "react-router-hash-link";
import {
  FaTwitter,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaGithub,
} from "react-icons/fa";
import { GiNigeria } from "react-icons/gi";
import { BsFillPersonFill } from "react-icons/bs";
import { MdLocationPin } from "react-icons/md";
import { GrProjects } from "react-icons/gr";
import { GiSkills } from "react-icons/gi";
import { BiCopyright } from "react-icons/bi";

function Footer() {
  return (
    <footer className="footer">
      <div className="form-contact-social-container">
        <section className="form-section" id="contact-form">
          <Form />
        </section>

        <div className="footer-info-container">
          <div className="footer-contact-menu-container">
            <div className="footer-contact-details">
              <h1 className="footer-contact-title">Contact me</h1>
              <div className="tel-div">
                <FaPhoneAlt className="tel-icon" />
                <span className="tel">+2347036671665</span>
              </div>
              <div className="email-div">
                <FaEnvelope className="email-icon" />
                <span className="email"> estherinyang07@gmail.com</span>
              </div>
              <div className="country-div">
                <MdLocationPin className="location-icon" />
                <span>
                  <span className="country">Lagos, Nigeria</span>
                  <GiNigeria className="country-icon" />
                </span>
              </div>
            </div>

            <div className="social-links">
              <h2 className="follow-social-title">Follow me</h2>
              <div className="social-icon-div">
                <FaGithub className="social-icon" />
                <a
                  href="https://github.com/esther-inyang"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  GitHub
                </a>
              </div>
              <div className="social-icon-div">
                <FaLinkedinIn className="social-icon" />
                <a
                  href="https://www.linkedin.com/in/estherinyang/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  LinkedIn
                </a>
              </div>
              <div className="social-icon-div">
                <FaTwitter className="social-icon" />
                <a
                  href="https://twitter.com/realdevesti"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  Twitter
                </a>
              </div>
            </div>

            <div className="footer-menu-div">
              <h2 className="about-me-footer-title">About me</h2>
              <ul className="footer-menu">
                <li>
                  <GiSkills className="footer-menu-icon" />
                  <HashLink to="#skill-section" className="footer-menu-link">
                    skills
                  </HashLink>
                </li>

                <li>
                  <GrProjects className="footer-menu-icon project-gr-icon" />
                  <HashLink to="#project-section" className="footer-menu-link">
                    projects
                  </HashLink>
                </li>

                <li>
                  <BsFillPersonFill className="footer-menu-icon" />
                  <a
                    href={pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-menu-link"
                  >
                    resume
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="copyrite-div">
        <span className="copyrite-text">copyrite</span>
        <BiCopyright className="copyrite-logo" />
        <span className="copyrite-year">{new Date().getFullYear()}</span>
        <span className="copyrite-divider">|</span>
        <span className="designed-by">
          Designed by
          <a
            href="https://github.com/esther-inyang"
            target="_blank"
            rel="noopener noreferrer"
            className="copyrite-name"
          >
            {" "}
            Esther Inyang
          </a>
        </span>
        <span className="copyrite-divider">|</span>
        <span className="all-rights">All rights reserved</span>
      </div>
    </footer>
  );
}

export default Footer;
